// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditWorkspaceForm__form-effbfe {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.EditWorkspaceForm__form-content-b2f3e2 {
  flex: 1;
  padding: 16px 24px;
  overflow: auto;
}

.EditWorkspaceForm__form-actions-dc53fd {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
}

.EditWorkspaceForm__image-field-a9bef3 {
  margin-bottom: 32px;
}

.EditWorkspaceForm__form-field-b8cc86 {
  margin-bottom: 12px;
}

.EditWorkspaceForm__description-d870ba {
  height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/EditWorkspacePopup/EditWorkspaceForm/EditWorkspaceForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;AACF;;AAEA;EACE,OAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".form {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.form-content {\n  flex: 1;\n  padding: 16px 24px;\n  overflow: auto;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px;\n}\n\n.image-field {\n  margin-bottom: 32px;\n}\n\n.form-field {\n  margin-bottom: 12px;\n}\n\n.description {\n  height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `EditWorkspaceForm__form-effbfe`,
	"form-content": `EditWorkspaceForm__form-content-b2f3e2`,
	"formContent": `EditWorkspaceForm__form-content-b2f3e2`,
	"form-actions": `EditWorkspaceForm__form-actions-dc53fd`,
	"formActions": `EditWorkspaceForm__form-actions-dc53fd`,
	"image-field": `EditWorkspaceForm__image-field-a9bef3`,
	"imageField": `EditWorkspaceForm__image-field-a9bef3`,
	"form-field": `EditWorkspaceForm__form-field-b8cc86`,
	"formField": `EditWorkspaceForm__form-field-b8cc86`,
	"description": `EditWorkspaceForm__description-d870ba`
};
module.exports = ___CSS_LOADER_EXPORT___;
